/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { ProfilesRequestBuilderNavigationMetadata, ProfilesRequestBuilderRequestsMetadata, type ProfilesRequestBuilder } from './profiles/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/payments/{customerNumber}
 */
export interface WithCustomerNumberItemRequestBuilder extends BaseRequestBuilder<WithCustomerNumberItemRequestBuilder> {
    /**
     * The profiles property
     */
    get profiles(): ProfilesRequestBuilder;
}
/**
 * Uri template for the request builder.
 */
export const WithCustomerNumberItemRequestBuilderUriTemplate = "{+baseurl}/api/payments/{customerNumber}";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const WithCustomerNumberItemRequestBuilderNavigationMetadata: Record<Exclude<keyof WithCustomerNumberItemRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    profiles: {
        requestsMetadata: ProfilesRequestBuilderRequestsMetadata,
        navigationMetadata: ProfilesRequestBuilderNavigationMetadata,
    },
};
/* tslint:enable */
/* eslint-enable */
